export * from './domains-descriptions-tree.model';
